import { useState } from 'react';
import { useForgotPasswordCustomer } from 'hooks';
import { getResourceImage, getResourceText } from 'lib/resources';
import { isString } from 'underscore';
import AccountWrapper from './account-wrapper';
import { PREFIX as accountSlug } from '../dashboard/slugs';

const ForgotPassword = ({
  page: {
    resources: { global, access },
  },
}) => {
  const tGlobal = getResourceText(global);
  const t = getResourceText(access);

  const [email, setEmail] = useState('');
  const [forgetPassword, { response, loading, error }] = useForgotPasswordCustomer();

  const handleSubmit = e => {
    e.preventDefault();
    forgetPassword(email);
  };

  const errorText = tGlobal('Server error text', 'Something went wrong, please try again later.');
  const loadingButtonText = tGlobal('Loading button text', 'Loading...');
  const emailLabel = tGlobal('Email label', 'Email');
  const completedTitle = t(
    'Forgot password completed title',
    'We have sent you a link to change your password.'
  );
  const completedText = t('Forgot password completed text', 'Please, also check your spam folder.');
  const title = t('Forgot password title', 'Reset password');
  const text = t('Forgot password text', 'We need your login / email to send you a reset link.');
  const buttonText = t('Forgot password submit button text', 'Send');

  return (
    <AccountWrapper
      className="[&>div:nth-child(2)]:place-items-start [&>div:nth-child(2)]:pt-32 [&>div:nth-child(2)]:md:place-items-center [&>div:nth-child(2)]:md:pt-0"
      backgroundImage={getResourceImage(access)('Background image')}
    >
      {response ? (
        <div className="flex flex-col gap-4">
          <h2 className="font-nimbus-sans-extd-d text-[2.5rem] font-bold uppercase leading-[85%] tracking-[-0.02em] text-blue">
            {completedTitle}
          </h2>
          <p className="text-body-1 font-nimbus-sans-d text-blue">{completedText}</p>
        </div>
      ) : (
        <form className="flex w-full flex-col gap-7 md:gap-9" onSubmit={handleSubmit}>
          <div className="flex flex-col gap-4">
            <h2 className="font-nimbus-sans-extd-d text-[2.5rem] font-bold uppercase leading-[85%] tracking-[-0.02em] text-blue">
              {title}
            </h2>
            <p className="text-body-1 font-nimbus-sans-d text-blue">{text}</p>
          </div>
          <input
            name="email"
            type="email"
            id="email"
            required
            placeholder={emailLabel}
            value={email}
            onChange={e => setEmail(e.target.value)}
            className="input text-body-1 w-full"
          />
          <div className="flex flex-col gap-1.5">
            <button type="submit" className="button w-full">
              {loading ? loadingButtonText : buttonText}
            </button>
            {error && (
              <p className="text-red-500 text-[12px]">
                {isString(error) ? t(error, error) : errorText}
              </p>
            )}
          </div>
          <a className="text-body-2 underline" href={`${accountSlug}/login/`}>
            {t('Back to Log In Text')}
          </a>
        </form>
      )}
    </AccountWrapper>
  );
};

export default ForgotPassword;
